import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import DisIcon from 'svgs/events/sme/discount.svg';
import formatNumber from 'utils/formatNumber';
import { calcTotal } from '../../../PricingTpl/Pricing/pricing.config';
import { content, disicon, hasDiscountC, isActive, price, priceUnit, priceWrapper, pricingText, pricingTextOrigin, root, tier, tierText, tierUnit } from './PricingCard.module.scss';

const PricingCard = ({ active, email, pricing, discount }) => (
  <div className={cn(root, { [isActive]: active })}>
    {discount.hasDiscount && <DisIcon className={disicon} />}
    <div className={cn(priceWrapper, { [hasDiscountC]: discount.hasDiscount })}>
      {discount.hasDiscount
        ? <span>
            <span className={pricingTextOrigin}>{calcTotal(email, pricing,)}</span>
            <span className={pricingText}>{calcTotal(email, pricing, discount.amount)}</span>
          </span>
        : <span className={pricingText}>{calcTotal(email, pricing)}</span>
      }
      <span className={priceUnit}>NT$</span>
    </div>
    <div className={content}>
      <div className={tier}>
        <span className={tierText}>{formatNumber(email)}</span>
        <span className={tierUnit}>封</span>
      </div>
      <div className={cn(price, { [hasDiscountC]: discount.hasDiscount })}>
        { discount.hasDiscount
          ? <span><span className={pricingTextOrigin}>{pricing}</span><span>{discount.pricing} / 封</span></span>
          : <span>{pricing} / 封</span>
        }
      </div>
    </div>
  </div>
);

PricingCard.propTypes = {
  active: PropTypes.bool,
  email: PropTypes.number.isRequired,
  pricing: PropTypes.string.isRequired,
  discount: PropTypes.object,
};
PricingCard.defaultProps = {
  discount: {
    hasDiscount: false,
  }
}

export default PricingCard;